// extracted by mini-css-extract-plugin
module.exports = {"sumsub":"style_sumsub__2jMry"};